import { AgrimotorProposer } from "./proposer.model";
import { AgriculturalVehicle } from "./vehicle-agricultural.model";
import { CarVehicle } from "./vehicle-car.model";
import { CommercialVehicle } from "./vehicle-commercial.model";
import { HorseboxVehicle } from "./vehicle-horsebox.model";
import { TrailerVehicle } from "./vehicle-trailer.model";
import { AgrimotorDriver } from "./drivers.model";
import { Fleet } from "./fleet.model";
export class Agrimotor {
    id: string = '';
    broker_id: string = '';
    company_id: string = '';
    sequence_number: number = null;
    broker_commission: number = null;
    broker_admin_fee: number = null;
    reference: string = '';
    status: string = '';
    declaration: boolean = null;
    inception_date: string = '';
    cover_to: string = '';
    proposer: any = new AgrimotorProposer();
    fleet_experiences: any = [new Fleet()];
    rating_type: string = '';
    vehicle_counts: any = {
        agricultural: 0,
        cars: 0,
        commercial: 0,
        horseboxes: 0,
        trailers: 0
    };
    agricultural_vehicles: any = [];
    cars: any = [];
    commercial_vehicles: any = [];
    horseboxes: any = [];
    trailers: any = [];
    vehicles: any[] = [];
    driver_conviction_declaration: boolean = null;
    driver_claim_declaration: boolean = null;
    additional_trades: any = [];
    drivers: any = [];
    voluntary_excess: number = null;
    is_referred: boolean = null;
    policy_id: string = '';
    effective_date: string = '';
    transactional_date: string = '';
    old_policy_id: string = '';
    discount: number = 0;
    type: number = 0;
}
